export function displayMemberName(person) {
  if (!person) return "";
  const parts = [];
  if (person.is_alive === false) parts.push("Late");
  if (person.gender === "Male") parts.push("Mr.");
  if (person.gender === "Female") parts.push("Ms.");
  parts.push(person.full_name || "");
  return parts.filter(Boolean).join(" ");
}
